'use client'

import { ExtendedEvent } from '../types'
import { getGameName } from '../utils/event-processor'
import AccessibleEvent from './AccessibleEvent'

interface MonthViewEventProps {
  event: ExtendedEvent
  onClick?: () => void
  onKeyboardNavigation?: (direction: 'up' | 'down' | 'left' | 'right') => void
}

/**
 * Component for rendering events in month view (limited space)
 */
export function MonthViewEvent({ event, onClick, onKeyboardNavigation }: MonthViewEventProps) {
  const { extendedProps } = event
  const gameName = getGameName(event)
  const maxPlayers = extendedProps?.maxPlayers || 0
  const currentPlayers = extendedProps?.participantCount || 0

  const renderContent = () => (
    <div className="fc-event-custom-content flex items-center overflow-hidden">
      <div className="flex flex-col flex-1">
        <div className="fc-event-title font-medium truncate flex items-center">
          {event.title}
          {/* Add a small capacity indicator dot for month view */}
          {maxPlayers > 0 && (
            <span
              className="ml-1 inline-block w-2 h-2 rounded-full"
              style={{
                backgroundColor:
                  currentPlayers >= maxPlayers
                    ? '#ef4444' // Red dot when full
                    : currentPlayers === maxPlayers - 1
                    ? '#f59e0b' // Yellow dot when only 1 spot left
                    : '#10b981', // Green dot when multiple spots available
              }}
              aria-hidden="true"
            ></span>
          )}
        </div>
        {gameName && (
          <div className="fc-event-game-name text-xs opacity-80 truncate">{gameName}</div>
        )}
      </div>
    </div>
  )

  return (
    <AccessibleEvent event={event} onClick={onClick} onKeyboardNavigation={onKeyboardNavigation}>
      {renderContent()}
    </AccessibleEvent>
  )
}
